/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IDataFrequentOperation } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-save-frequent-operation',
	templateUrl: './save-frequent-operation.component.html',
	styleUrls: ['./save-frequent-operation.component.scss'],
	providers: [
		{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SaveFrequentOperationComponent), multi: true }
	]
})
export class SaveFrequentOperationComponent implements ControlValueAccessor, OnInit {
	@Input() dataFrequentOperation!: IDataFrequentOperation;
	@Output() changeToggleFavorite = new EventEmitter<IDataFrequentOperation>();

	minlength = 3;

	private _onChange = (_value: IDataFrequentOperation) => {};
	private _onTouched = () => {};

	ngOnInit(): void {
		if (!this.dataFrequentOperation) {
			setTimeout(() => {
				this.dataFrequentOperation = { nameFrequentOperation: '', isValid: false, isSelected: false };
			}, 0);
		}
	}
	writeValue(obj: any): void {
		this.dataFrequentOperation = obj;
	}

	registerOnChange(fn: any): void {
		this._onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this._onTouched = fn;
	}

	changeFrequentOperation(): void {
		this.dataFrequentOperation.isValid = this._isValid();
		this._onTouched();
		this._onChange(this.dataFrequentOperation);
	}

	changeToggle(): void {
		this.dataFrequentOperation.isValid = this._isValid();
		if (!this.dataFrequentOperation.isSelected) {
			this.dataFrequentOperation.nameFrequentOperation = '';
		}

		this._onTouched();
		this._onChange(this.dataFrequentOperation);
		this.changeToggleFavorite.emit(this.dataFrequentOperation);
	}

	private _isValid(): boolean {
		return (
			this.dataFrequentOperation !== null &&
			this.dataFrequentOperation !== undefined &&
			this.dataFrequentOperation.nameFrequentOperation.trim() !== '' &&
			this.dataFrequentOperation.nameFrequentOperation.length >= this.minlength
		);
	}

	get value(): IDataFrequentOperation {
		return this.dataFrequentOperation;
	}

	set value(val: IDataFrequentOperation) {
		this.dataFrequentOperation = val;
		this._onChange(val);
		this._onTouched();
	}
}
